import React, { useEffect, useState } from "react";
import { Postdata } from "../../helpers/api.service";
import HttpService from "../../helpers/httpServices";
import { useDispatch } from "react-redux";
import { message } from "../../redux/actions/toastActions";
import { useLocation, useNavigate } from "react-router-dom";

const options = [
    { label: "Name", value: "name" },
    { label: "Email ID", value: "email" },
    { label: "Phone Number", value: "phone" },
    { label: "Description", value: "description" },
];

const Contactus = () => {
    const [selectedOptions, setSelectedOptions] = useState(["email"]);
    const [showDropdown, setShowDropdown] = useState(false);
    const [data, setData] = useState({
        name: false,
        email: true,
        phone: false,
        description: false,
    });
    const [loader, setLoader] = useState(false);
    const dispatch = useDispatch()
    const [refresh, setRefresh] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();


    const handleToggleOption = (value) => {
        setSelectedOptions((prev) => {
            let newOptions;

            // Prevent unchecking "email"
            if (value === "email" && prev.includes("email")) return prev;

            if (prev.includes(value)) {
                newOptions = prev.filter((v) => v !== value);
            } else {
                newOptions = [...prev, value];
            }

            // Immediately update FormData based on the new options
            handleSubmit(newOptions); // <-- Trigger submit
            return newOptions;
        });
    };

    const fetchData = (req, res) => {
        setLoader(false);
        Postdata(HttpService.school_contact_field_show).then((res) => {
            if (res.status === 200) {


                // Extract selected fields from the received object
                const selected = options
                    .filter(opt => res.data[opt.value] === true)
                    .map(opt => opt.value);

                // Always include "email" even if not returned (because it's required)
                if (!selected.includes("email")) selected.push("email");

                setData(res.data);
                setSelectedOptions(selected); // <-- Sync selected checkboxes
            }else{

                dispatch(message(res.message));
            }
        })
    }

    const handleSubmit = (newOptions) => {
        setLoader(true);

        const formData = new FormData();
        options.forEach((option) => {
            formData.append(option.value, newOptions.includes(option.value));
        });
        formData.append("id", data._id)
        Postdata(HttpService.school_contact_field_add, formData).then((res) => {
            if (res.status === 200) {
                setRefresh(!refresh);
            }else{

                dispatch(message(res.message));
            }
            setLoader(false);
        });
    }

    useEffect(() => {
        fetchData();
    }, [refresh])
    useEffect(() => {
        // Navigate to /settings with currentTab only once
        if (location?.state?.currentTab !== "Contact Us") {
            navigate("/settings", {
                state: { currentTab: "Contact Us" },
                replace: true,
            });
        }
    }, []);

    return (
        <div className="rounded-lg p-6 relative text-gray-800 max-w-md ">
            <h2 className="text-2xl font-semibold mb-4">Contact Us</h2>

            {/* Selected tags */}
            <div className="flex gap-2 mb-4 flex-wrap">
                {selectedOptions.map((val) => {
                    const label = options.find((o) => o.value === val)?.label;
                    return (
                        <div key={val} className="border border-purple-400 text-primary_main px-4 py-1 rounded-full text-sm">
                            {label}
                        </div>
                    );
                })}
            </div>

            {/* Dropdown */}
            <div className="relative">
                <div
                    className={` border-blue-400 p-3 flex bg-white justify-between rounded cursor-pointer select-none border-b-0 ${showDropdown ? 'border-b-0' : ''}`}
                    onClick={() => setShowDropdown(!showDropdown)}
                >
                    <div className="text-gray-600">Select</div>
                    <svg
                        className={`w-5 h-5 transform transition-transform duration-300 ${showDropdown ? 'rotate-180' : 'rotate-0'}`}
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        viewBox="0 0 24 24"
                    >
                        <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                    </svg>
                </div>

                {showDropdown && (
                    <div className="absolute bg-white  border-blue-400 w-full rounded  p-2 z-10">
                        {options.map((option) => (
                            <label key={option.value} className="flex items-center space-x-2 py-1">
                                <input
                                    type="checkbox"
                                    checked={selectedOptions.includes(option.value)}
                                    onChange={() => handleToggleOption(option.value)}
                                    className="accent-primary_main"
                                    disabled={option.value == "email"}
                                />
                                <span>{option.label}</span>
                            </label>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Contactus;
